<ion-app appFixNbsp>
  @if (showValideAnimation()) {
    <app-certificat-valide (done)="showValideAnimation.set(false)"></app-certificat-valide>
  } @else if (isRejeteUser()) {
    <app-certificat-rejete
      [rejectionReason]="rejectionReason()"
      (refresh)="refreshUserProfile()"
      (logout)="handleLogout()">
    </app-certificat-rejete>
  } @else if (isAttenteUser()) {
    <app-certificat-attente
      (refresh)="refreshUserProfile()"
      (logout)="handleLogout()">
    </app-certificat-attente>
  } @else {
    <div class="router-container" [@routeAnimations]="getRouteAnimationData()">
      <ion-router-outlet [animated]="false"></ion-router-outlet>
    </div>
    <app-bottom-nav></app-bottom-nav>
  }
  <app-cookie-consent
    [legalContentService]="legalContentService"
    [cookieConsentService]="cookieConsentService">
  </app-cookie-consent>
  <app-pwa-install-banner></app-pwa-install-banner>
  <app-notification-modal
    [appNotificationService]="appNotificationService">
  </app-notification-modal>
</ion-app>
